import * as WebAuthnJSON from '@github/webauthn-json'
import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest, type FetchResponse } from '@rails/request.js'

// Connects to data-controller="webauthn-register"
export default class extends Controller {
  static targets = [
    'nickname',
    'createButton',
  ]

  declare readonly nicknameTarget: HTMLInputElement
  declare readonly createButtonTarget: HTMLButtonElement

  static values = {
    challengeUrl: String,
    verificationUrl: String,
  }

  declare challengeUrlValue: string
  declare verificationUrlValue: string

  connect () {
    // TODO: use WebAuthnJSON.supported() to check if the browser supports WebAuthn, and handle the case where it
    // doesn't.
  }

  nicknameChanged (_event: InputEvent) {
    this.createButtonTarget.disabled = this.nicknameTarget.value.length === 0
  }

  async create () {
    try {
      const challengeResponse = await this.#request('post', this.challengeUrlValue)
      const credentialResponse = await WebAuthnJSON.create({ publicKey: challengeResponse })
      this.#onCompletion(await this.#verify(credentialResponse))
    } catch (error) {
      this.#onError(error)
    }
  }

  async #verify (credentialResponse: WebAuthnJSON.PublicKeyCredentialWithAttestationJSON): Promise<any> {
    return await this.#request('post', this.verificationUrlValue, {
      body: JSON.stringify({
        credential: credentialResponse,
        nickname: this.nicknameTarget.value
      }),
      contentType: 'application/json',
      responseKind: 'json'
    })
  }

  #onCompletion (_response: FetchResponse): void {
    window.location.reload()
  }

  #onError (error: any): void {
    console.error('Something went wrong', error)
  }

  async #request (method: string, url: string, options = {}): Promise<any> {
    const request = new FetchRequest(method, url, { redirect: 'error', responseKind: 'json', ...options })
    const response = await request.perform()
    return response.json
  }
}
